import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2628fb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["xlink:href"]

type Props = {
  name: string;
  color?:string;
  size?:string|number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    name: { default: "" },
    color: { default: "" },
    size: { default: '' }
  },
  setup(__props: any) {

const props = __props as { name: string, color:string, size:string|number };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: "svg-icon",
    style: _normalizeStyle({color:props.color,width:props.size+'px',height:props.size+'px'})
  }, [
    _createElementVNode("use", {
      "xlink:href": `#icon-${props.name}`
    }, null, 8, _hoisted_1)
  ], 4))
}
}

})